import { render, staticRenderFns } from "./SupplierPicker.vue?vue&type=template&id=a3bc433c&scoped=true&"
import script from "./SupplierPicker.vue?vue&type=script&lang=js&"
export * from "./SupplierPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3bc433c",
  null
  
)

export default component.exports